import z from "zod";
import EventOccasionService from "../../../../services/EventOccasionService";
import { mapErrorsToFields } from "../../../../utils";

const api = new EventOccasionService();
export type State = {
  message: string | null;
  errors?: {
    name?: string[];
    general?: string[];
  };
  success: boolean;
  defaultValues: {
    name?: string;
  };
};

const FormSchema = z.object({
  name: z.string().min(1, { message: "Name is required." }),
});

export async function createEventOccasion(
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() || "",
  };
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);
    if (!validatedFields.success) {
      return {
        errors: mapErrorsToFields(validatedFields.error),
        message: "Failed to create event occasion.",
        defaultValues,
        success: false,
      };
    }
    const result = await api.createEventOccasion(validatedFields.data);
    if (result.status === 201)
      return {
        errors: {},
        message: "Event Occasion created successfully.",
        defaultValues,
        success: true,
      };
    else if (result.status === 400)
      return {
        errors: {},
        message: result.data.description,
        defaultValues,
        success: false,
      };
  } catch (error) {
    console.error("Error creating event occasion:", error);
  }
  return {
    errors: {},
    message: "Failed to create event occasion.",
    defaultValues,
    success: false,
  };
}

export async function updateEventOccasion(
  id: string,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() || "",
  };
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);
    if (!validatedFields.success) {
      return {
        errors: mapErrorsToFields(validatedFields.error),
        message: "Failed to update event occasion.",
        defaultValues,
        success: false,
      };
    }
    const result = await api.updateEventOccasion({
      id: parseInt(id),
      ...validatedFields.data,
    });
    if (result.status === 204)
      return {
        errors: {},
        message: "Event Occasion updated successfully.",
        defaultValues,
        success: true,
      };
  } catch (error) {
    console.error("Error updating event occasion:", error);
  }
  return {
    errors: {},
    message: "Failed to update event occasion.",
    defaultValues,
    success: false,
  };
}

export async function deleteEventOccasion(
  id: string
): Promise<{ success: boolean }> {
  try {
    const result = await api.deleteEventOccasion(parseInt(id));
    return { success: result.status === 204 };
  } catch (error) {
    console.error("Database Error:", error);
  }
  return { success: false };
}



